<template>
  <div>
    <div class="px-5">
      <div class="text-h4 font-weight-black">Terms and Conditions</div>
      <div style="font-size: 10px">Last updated: April 15, 2021</div>
    </div>
    <div class="px-5 mt-5">
      <div class="font-weight-medium">Syarat dan Ketentuan</div>
      <div>
        <p style="font-size: 12px">
          Dengan mengunduh, mengakses dan/atau menggunakan aplikasi mobile Teman
          Bakat, Anda setuju bahwa Anda telah menerima, membaca, dan memahami
          seluruh informasi terkait Syarat dan Ketentuan penggunaan Aplikasi
          Teman Bakat ini. Syarat dan Ketentuan ini merupakan suatu perjanjian
          yang sah terkait persyaratan dan tata cara penggunaan aplikasi antara
          Teman Bakat (selanjutnya disebut sebagai “Kami”) dengan Anda selaku
          pengguna. Apabila Anda tidak setuju untuk terikat dengan seluruh
          Syarat dan Ketentuan ini, Anda dapat menghapus aplikasi dan/atau tidak
          menggunakan layanan yang terdapat dalam aplikasi.
        </p>
      </div>
    </div>
    <div class="px-5 mt-5">
      <div class="font-weight-medium">Syarat dan Ketentuan Umum</div>
      <div style="font-size: 12px">
        <!-- <p style="font-size:12px;"> -->
        a. Aplikasi Teman Bakat berbasis android yang dikelola oleh Kami. <br />
        b. Aplikasi ini berfungsi sebagai sarana untuk Anda melakukan psikotes,
        konsultasi dan pengembangan diri. <br />
        c. Anda memerlukan koneksi internet untuk dapat mengakses layanan yang
        ada di dalam aplikasi Kami. <br />
        d. Aplikasi ini memiliki beberapa layanan yang dapat digunakan. Adapun
        jenis layanan tersebut sebagai berikut: <br />
        <ul style="list-style-type: none">
          <li>I. Psikotes</li>
          <li>II. Konsultasi</li>
          <li>II. Konsultasi</li>
          <li>III. Pengembangan Diri</li>
          <li>IV. Skill Training & Workshop</li>
          <li>V. Self-Development Material</li>
        </ul>
        <br />
        e. Dalam layanan konsultasi, Kami akan menghubungkan Anda dengan
        psikolog/konselor profesional yang berlisensi. Berlisensi berarti
        memiliki Surat Izin Praktik Psikologi dari Himpunan Psikologi Indonesia
        (HIMPSI). <br />
        f. Anda menyetujui bahwa seluruh percakapan yang Anda lakukan dengan
        konselor/psikolog Teman Bakat akan tersimpan secara otomatis.
        Kerahasiaan percakapan Anda terjaga dan tidak akan disebarluaskan.
        <br />
        g. “Pihak Ketiga” adalah setiap orang, perusahaan, atau badan hukum yang
        mengadakan kerjasama dengan kami. <br />
        h. Fitur yang ada di aplikasi Teman Bakat dapat diperbarui seiring
        dengan perkembangan platform. <br />
        i. Anda dapat memberikan informasi berupa data diri yang akan Kami jaga
        kerahasiaannya. Data tersebut akan kami jaga dan pergunakan untuk
        kebutuhan psikotes dan layanan konsultasi. <br />
        j. Dengan menggunakan layanan pada aplikasi Teman Bakat, Anda menyetujui
        bahwa seluruh data diri, aktivitas, dan percakapan yang terjadi di dalam
        aplikasi akan secara otomatis tersimpan dan diarsipkan oleh aplikasi
        Kami. <br />
        k. Kami dapat menghentikan proses penggunaan aplikasi jika menemukan
        adanya pelanggaran yang dilakukan oleh Anda.
        <!-- </p> -->
      </div>
    </div>
    <div class="px-5 mt-5">
      <div class="font-weight-medium">Ketentuan Pembayaran</div>
      <div>
        <p style="font-size: 12px">
          a. Terdapat beberapa metode pembayaran pada aplikasi yang dapat Anda
          gunakan ketika melakukan pembayaran. <br />
          b. Dalam transaksi pembayaran, kami menggunakan jasa pihak ketiga.
          Oleh karena itu jika terjadi kegagalan pada sistem pembayaran, Kami
          akan berusaha untuk menyelesaikan masalah tersebut sehingga Anda dapat
          menggunakan layanan kami secara optimal. <br />
          c. Seluruh transaksi layanan di aplikasi Kami menggunakan sistem poin.
          Anda dapat memperoleh poin dengan memainkan misi yang tersedia pada
          aplikasi. <br />
          d. Anda dapat menambah poin dengan membeli paket poin dan melakukan
          pembayaran sesuai dengan harga yang tertera. <br />
          e. Untuk menuntaskan pembayaran pada pembelian poin, Anda perlu
          mengunggah bukti transfer yang kemudian akan diverifikasi oleh Kami
          sesuai batas waktu yang telah diberitahukan pada aplikasi. <br />
          f. Pembayaran Anda akan dibatalkan secara otomatis apabila Anda tidak
          melakukan pembayaran pada batas waktu yang telah ditentukan yaitu 2 x
          24 jam setelah check out <br />
          g. Saldo poin Anda akan bertambah ketika Kami sudah melakukan
          verifikasi atas pembayaran pembelian poin. <br />
          h. Saldo poin Anda akan terpotong secara otomatis ketika Anda
          melakukan pembayaran layanan pada keranjang pesanan Anda. <br />
          i. Apabila Anda telah melakukan pembayaran, maka Anda tidak dapat
          mengubah layanan yang telah dipilih. Kecuali Anda memesan dan membayar
          ulang pesanan paket lainnya <br />
          j. Transaksi atau layanan yang sudah dilakukan pada aplikasi Teman
          Bakat, Tidak Dapat dilakukan pengembalian (refund). Jika terjadi error
          atau kendala, harap menghubungi kami pada kontak yang tersedia. <br />
        </p>
      </div>
    </div>
    <div class="px-5 mt-5">
      <div class="font-weight-medium">Ketentuan Penggunaan Aplikasi</div>
      <div>
        <p style="font-size: 12px">
          a. Anda dapat mengakses seluruh fitur pada aplikasi Teman Bakat,
          termasuk memilih layanan yang tersedia dengan melakukan pendaftaran
          akun. Seluruh data pribadi yang Anda cantumkan dapat dipertanggung
          jawabkan secara hukum. Informasi mengenai data pribadi hanya kami
          gunakan untuk kebutuhan layanan. <br />
          b. Proses pendaftaran mewajibkan Anda untuk mengisi data pribadi yang
          akurat, terkini dan lengkap. Apabila terdapat perubahan dala data diri
          Anda, segera melaporkannya pada aplikasi. <br />
          c. Setelah melakukan pendaftaran, Anda akan mendapat verifikasi
          melalui e-mail yang Anda daftarkan. Kami harap Anda tidak menyerahkan
          ataupun memberikan wewenang pada orang lain untuk menggunakan akun
          Anda. Anda diwajibkan untuk menjaga kerahasiaan data akun, termasuk
          e-mail maupun kata sandi akun Anda. Apabila terjadi kebocoran pada
          data akun Anda bukan atas kesalahan kami, transaksi layanan yang
          dilakukan di dalam aplikasi masih akan dianggap sebagai transaksi yang
          sah kecuali apabila terdapat pelaporan dari Anda terkait
          penyalahgunaan akun tersebut. <br />
          d. Anda bertanggung jawab sepenuhnya dalam menjaga agar nama akun dana
          ta sandi Anda di aplikasi tetap aman. <br />
          e. Anda menyetujui bahwa seluruh informasi dalam bentuk apapun, baik
          itu tulisan, video, gambar, maupun alat tes psikologi yang ada di
          dalam aplikasi memiliki hak cipta dan kekayaan intelektual. Oleh
          karena itu Anda tidak diperbolehkan untuk menggunakan, mengubah,
          dan/atau menyebarluaskan hak tersebut tanpa izin dari kami. <br />
          f. Anda mengetahui dan menyetujui bahwa tarif layanan yang ada di
          dalam aplikasi dapat mengalami perubahan. <br />
          g. Hak Anda untuk menggunakan layanan akan berakhir ketika akun Anda
          telah dihapus untuk alasan apapun. <br />
          h. Kami dapat memblokir akun Anda apabila terjadi penyalahgunaan fitur
          saat melakukan konsultasi chat dengan psikolog. <br />
        </p>
      </div>
    </div>
    <div class="px-5 mt-5">
      <div class="font-weight-medium">
        Psikolog, Konselor dan Layanan Konsultasi
      </div>
      <div>
        <p style="font-size: 12px">
          a. Anda menyetujui dan mengakui bahwa layanan konsultasi di aplikasi
          Teman Bakat tidak dapat dijadikan sebagai satu-satunya acuan atas
          permasalahan Anda. <br />
          b. Para Psikolog dan Konselor memiliki komitmen untuk dapat memberikan
          upaya aksimal dalam mendengarkan, membantu, dan memberikan saran atas
          permasalahan Anda dan melindungi informasi pribadi Anda. <br />
        </p>
      </div>
    </div>
    <div class="px-5 mt-5">
      <div class="font-weight-medium">Ketentuan Lainnya</div>
      <div>
        <p style="font-size: 12px">
          a. Teman Bakat dapat merubah Syarat dan Ketentuan sewaktu-waktu.
          <br />
          b. Anda dapat membeli transaksi lainnya jika sudah menyelesaikan
          transaksi yang sudah dipesan. <br />
          c. Layanan yang telah dibeli tidak dapat dibatalkan. <br />
          d. Layanan tidak dapat dialihkan pada pengguna lain. <br />
          e. Anda dapat menggunakan kupon promo yang diberikan oleh HRIndo untuk
          membeli layanan yang ada di aplikasi Teman Bakat. <br />
          f. Anda dilarang untuk mengakses API private aplikasi Teman Bakat
          selain mendapat izin dari kami. <br />
          g. Anda tidak diperbolehkan untuk mengganggu layanan atau server yang
          berhubungan dengan layanan, misalnya dengan mengirimkan virus. <br />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TermCondition",
};
</script>
